import { QuickViewProps } from "@~/product-card-components/__shared__/QuickViewModal/QuickViewModal.tsx";
import { Product } from "@~/types/types.ts";

export function getAnalyticsData(
  product: Product,
  originator: QuickViewProps["originator"],
) {
  let interaction: string | undefined;
  switch (originator) {
    case "QUICK_VIEW_ICON":
      interaction = "plpQuickviewIcon";
      break;
    case "VIEW_OFFERS":
      interaction = "plpViewoffers";
      break;
    case "ADD_TO_BASKET":
      interaction = "plpAddToBasket";
      break;
    case "PRODUCT_CARD":
      interaction = "productCard";
      break;
    default:
      break;
  }

  const { associatedAdvertId, clickUrl } = product.advertising ?? {};
  const isKevelProduct = clickUrl !== undefined;

  return {
    product: {
      ...(associatedAdvertId && !isKevelProduct
        ? { citrusId: associatedAdvertId }
        : {}),
      ...(associatedAdvertId && isKevelProduct
        ? { kevelAdId: associatedAdvertId }
        : {}),
    },
    event: {},
    additionalInfo: {
      ...(interaction ? { interaction } : {}),
    },
  };
}
